import { createSlice } from '@reduxjs/toolkit';

import { loadBidderCardStatus } from '@/redux/modules/account/payments/creditCard/cardStatus/bidderCardStatus.actions';
import { defaultBidderCardStatusSlice } from '@/redux/modules/account/payments/creditCard/cardStatus/bidderCardStatus.types';

const bidderCardStatusSlice = createSlice({
    extraReducers: (builder) => {
        builder.addCase(loadBidderCardStatus.pending, (slice) => {
            slice.isLoading = true;
        });
        builder.addCase(loadBidderCardStatus.fulfilled, (slice, { payload }) => {
            if (!payload) {
                return slice;
            }
            slice.isLoading = false;
            slice.status = payload;
        });
        builder.addCase(loadBidderCardStatus.rejected, (slice) => {
            slice.isLoading = false;
            slice.status = defaultBidderCardStatusSlice.status;
        });
    },
    initialState: defaultBidderCardStatusSlice,
    name: 'bidderCardStatusSlice',
    reducers: {},
});

export const { reducer: bidderCardStatusReducer } = bidderCardStatusSlice;
